export default {
  index: [
    {
      path: '/zkproduct',
      component: resolve => require(['./zkproductIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkproduct/_router.js